<template>
  <div class="chart-wrap">
    <div class="top-hd">
      <h1> {{ chartTitle }}</h1>
      <div style="display: flex; gap: 12px;">
      <button class="img-save" type="button" style="width: 120px; background: #fff; color: #2a2c2f; border: 1px solid #2a2c2f;" @click="saveChartToImg()">이미지 저장</button>
      <button class="close-btn" type="button"  @click="popupClose()">닫기</button>
      </div>
    </div>
    <div class="filter-chart-area">
      <div class="l">
        <h2 @click="saveChartToImg">차트 조회 설정</h2>
        <!-- 조회설정(필터) 레이어 -->
        <div v-bind:ref="'filterChart'" class="filter-fix-box" style="height: calc(100% - 37px);">
          <!-- 조회설정(필터) -->
          <div v-show="filterTab === 'filter'" ref="filterSetting" class="pannel" style="display: none; height: 100%">
            <div class="filter-list-inner">
              <div class="filter-list-box" style="height: 30px;">
                <!-- 검색 영역 -->
                <div class="filter-search">
                  <input type="search" style="background: #f9f9f9;" v-model="filterSearchText" v-on:keyup.enter="filterSearch" placeholder="필터 검색">
                  <div v-show="filterSearchTotalCount > 0" style="display: flex;">
                    <span style="font-size: 12px; margin: 0 8px;"> {{filterSearchCurrent}}/{{filterSearchTotalCount}}</span>
                    <button type="button" @click="moveSearchIndex('up')" class="filter-search-up"></button>
                    <button type="button" @click="moveSearchIndex('down')" class="filter-search-down"></button>
                    <button type="button" @click="moveSearchIndex('delete')" class="filter-search-close"></button>
                  </div>
                </div>
              </div>
              <div class="filter-list-box">
                <div class="filter-tit">
                  <h5>시점 (연도)</h5>
                  <button class="filterListToggle" type="button" @click="filterListToggle($event)"><span class="hidden">버튼</span></button>
                </div>
                <div class="check-list-box">
                  <ul>
                    <li>
                    <span class="inp-box">
                      <label>
                        <input type="checkbox" ref="checkAllYear" v-model="filterChecker.year.checked"  checked data-all-check="all" @change="filterAllCheck($refs.yearTreeChecker, $event)">
                        <span class="filter-list-Label">전체 선택</span>
                      </label>
                    </span>
                    </li>
                    <!-- 시점 반복 START-->
                    <TreeChecker ref="yearTreeChecker" v-for="(data, i) in arrayYearItemFilterData"
                                 @checked-update="allCheckFromChild(arrayYearItemFilterData, $refs.checkAllYear, filterChecker.year)"
                                 :item="data" :index="i.toString()" :code="'col'" v-bind:key="i">
                    </TreeChecker>
                    <!-- 시점 반복 END-->
                  </ul>
                </div>
              </div>
              <div class="filter-list-box">
                <div class="filter-tit">
                  <h5>항목 ({{ colFilterDisplay.join(',') }})</h5>
                  <button class="filterListToggle" type="button" @click="filterListToggle($event)"><span class="hidden">버튼</span></button>
                </div>
                <div class="check-list-box">
                  <ul>
                    <li>
                    <span class="inp-box">
                      <label>
                        <input type="checkbox" ref="checkAllCol" v-model="filterChecker.col.checked" data-all-check="all" checked @change="filterAllCheck($refs.colTreeChecker, $event)">
                        <span class="filter-list-Label">전체 선택</span>
                      </label>
                    </span>
                    </li>
                    <!-- 표두 반복 START-->
                    <TreeChecker ref="colTreeChecker" v-for="(data, i) in arrayColItemFilterData"
                                 @checked-update="allCheckFromChild(arrayColItemFilterData, $refs.checkAllCol, filterChecker.col)"
                                 :item="data" :index="i.toString()" :code="'col'" v-bind:key="i">
                    </TreeChecker>
                    <!-- 표두 반복 END-->
                  </ul>
                </div>
              </div>
              <div class="filter-list-box">
                <div class="filter-tit">
                  <h5>통계분류 ({{ rowFilterDisplay.join(',') }})</h5>
                  <button class="filterListToggle" type="button" @click="filterListToggle($event)"><span class="hidden">버튼</span></button>
                </div>
                <div class="check-list-box">
                  <ul>
                    <li>
                      <span class="inp-box">
                        <label>
                          <input type="checkbox" ref="checkAllRow" v-model="filterChecker.row.checked" data-all-check="all" checked @change="filterAllCheck($refs.rowTreeChecker, $event)">
                          <span class="filter-list-Label">전체 선택</span>
                        </label>
                      </span>
                    </li>
                    <!-- 표측 반복 START-->
                    <TreeChecker ref="rowTreeChecker" v-for="(data, i) in arrayRowItemFilterData"
                                 @checked-update="allCheckFromChild(arrayRowItemFilterData, $refs.checkAllRow, filterChecker.row)"
                                 :item="data" :index="i.toString()" :code="'row'" v-bind:key="i">
                    </TreeChecker>
                    <!-- 표측 반복 END-->
                  </ul>
                </div>
              </div>
              <div class="pop-btn-box align-c">
                <button type="button" class="pop-btn w-fix bg-blue" @click="filterApply()">차트생성</button>
              </div>
            </div>
          </div>
          <!-- // 조회설정(필터) -->
        </div>

      </div>
      <div class="r">
        <SpinnerChart ref="SpinnerChart" :loading="showSpinner"></SpinnerChart>
        <div class="chart-type-list" v-show="!showSpinner">
          <ul class="chart-type">
            <li><button type="button" @click="selectChart('column', 'columnGroup', true)" :class="selectChartIcon === 'columnGroup' ? 'chart-selected': ''" class="btn-chart-type1"><span class="hidden">막대차트</span></button></li>
            <li><button type="button" @click="selectChart('column', 'column', false)" :class="selectChartIcon === 'column' ? 'chart-selected': ''" class="btn-chart-type2"><span class="hidden">막대차트</span></button></li>
            <li><button type="button" @click="selectChart('line', 'line', true)" :class="selectChartIcon === 'line' ? 'chart-selected': ''" class="btn-chart-type3"><span class="hidden">꺽은선차트</span></button></li>
            <li><button type="button" @click="selectChart('spline', 'spline', true)" :class="selectChartIcon === 'spline' ? 'chart-selected': ''" class="btn-chart-type4"><span class="hidden">곡선차트</span></button></li>
            <li><button type="button" @click="selectChart('line', 'step', true)" :class="selectChartIcon === 'step' ? 'chart-selected': ''" class="btn-chart-type5"><span class="hidden">계단형차트</span></button></li>
            <li><button type="button" @click="selectChart('bar', 'barGroup', true)" :class="selectChartIcon === 'barGroup' ? 'chart-selected': ''" class="btn-chart-type6"><span class="hidden">바차트</span></button></li>
            <li><button type="button" @click="selectChart('bar', 'bar', false)" :class="selectChartIcon === 'bar' ? 'chart-selected': ''" class="btn-chart-type7"><span class="hidden">바차트</span></button></li>
            <li><button type="button" @click="selectChart('area', 'area', false)" :class="selectChartIcon === 'area' ? 'chart-selected': ''" class="btn-chart-type8"><span class="hidden">영역차트-꺽은선</span></button></li>
            <li><button type="button" @click="selectChart('areaspline', 'areaspline', false)" :class="selectChartIcon === 'areaspline' ? 'chart-selected': ''" class="btn-chart-type9"><span class="hidden">영역차트-곡선</span></button></li>
          </ul>
          <div v-show="isShow" class="chart-option">
            <div v-show="infoItem.msrUnitNm !== null && infoItem.msrUnitNm !== ''" class="chart-unit"><p>단위 : {{ infoItem.msrUnitNm }}</p></div>
          </div>
        </div>
        <div v-show="!showSpinner" class="ibchart-wrap-filter">
          <div class="ibchart-box-filter">
            <div id="chartDiv"></div>
          </div>
        </div>
      </div>
    </div>
	</div>

</template>

<script>
import $ from 'jquery'
import MultiSelect from "@/components/select/MultiSelect";
import pivotPopup from "@/components/popup/pivotPopup.vue";
import TreeChecker from "@/components/tree/TreeChecker.vue";
import SpinnerChart from "../../components/SpinnerChart.vue";

export default {
	name: 'ChartPopup',
	components: {
    SpinnerChart,
    TreeChecker, pivotPopup,
    MultiSelect
	},
	mounted() {
    if (window.opener === null || window.opener.openerVue === undefined) {
      alert("비정상적인 접근입니다.");
      // 필요시 후처리
    } else {
      this.arrayRowItemFilterData = window.opener.openerVue.$data.arrayRowItemFilterData;
      this.arrayColItemFilterData = window.opener.openerVue.$data.arrayColItemFilterData;
      this.arrayRowItemTitleData = window.opener.openerVue.$data.arrayRowItemTitleData;
      this.arrayColItemTitleData = window.opener.openerVue.$data.arrayColItemTitleData;
      this.arrayData = window.opener.openerVue.$data.arrayChartData;
      //this.arrayData = window.opener.openerVue.$data.arrayDataFilter;
      this.infoItem =  window.opener.openerVue.infoItem;
      this.chartSetOption =  window.opener.openerVue.chartSetOption;
      this.isIndexYn = window.opener.openerVue.isIndexYn;
      this.chartTitle = this.infoItem.tblKorNm;
      this.colFilterDisplay = window.opener.openerVue.colFilterDisplay;
      this.rowFilterDisplay = window.opener.openerVue.rowFilterDisplay;
      this.filterChecker = window.opener.openerVue.$data.filterChecker;

      // 최근 5년치 데이터 처리
      if (this.last5Year){
        this.arrayYearItemFilterData = window.opener.openerVue.$data.arrayYearItemFilterData.slice(0,5);
      } else {
        this.arrayYearItemFilterData = window.opener.openerVue.$data.arrayYearItemFilterData;
      }
    }
	},
  data () {
    return {
      arrayRowItemFilterData : []
      , arrayColItemFilterData: []
      ,arrayRowItemTitleData : []
      ,arrayColItemTitleData : []
      ,arrayYearItemFilterData : []
      ,arrayData: {}
      ,arrayDataFilter: {}  // 차트를 생성하기 위한 초기 데이터
      ,activeButton: 0
      ,delimiterCha: '▷'   // 데이터처리 구분자
      ,chartOptions: {}
      ,chartSetOption: {}
      ,stblChartId: "chartDiv" // + this.itemIdx  // 차트 객체 ID
      ,arrayRowItemSub : {}
      ,infoItem : {}
      ,allValueCheck: false
      ,isLast : false
      ,chartType: 'column'
      ,chartName: 'columnGroup'
      ,stackYn: true
      ,isIndexYn: false
      ,selectYearObject: {}
      ,lastItemName: ''
      ,filterResult: []
      ,last5Year: true
      ,selectChartIcon: 'columnGroup'
      ,chartTitle:''
      ,isShow: true
      ,filterTab : 'filter'
      ,filterSearchText: ''
      ,filterSearchList: []
      ,filterSearchTotalCount: 0
      ,filterSearchCurrent : 1
      ,colFilterDisplay: []
      ,rowFilterDisplay: []
      ,showSpinner : false
      ,filterChecker: {
        year : {checked : true},
        col : {checked : true},
        row : {checked : true}
      }
    }
  },
  methods: {
    /**
     * 팝업 닫기
     */
    popupClose() {
      window.close()
    },
    /**
     * 필터 리스트 토글 처리
     * @param evt
     */
    filterListToggle(evt) {
      const target = evt.target
      $(target).parents('.filter-list-box').toggleClass('off')
      $(target).toggleClass('close')
    },
    /**
     * 필터 검색
     */
    filterSearch(){
      this.initFilterSearchResult();
      if (this.filterSearchText.trim().length > 0) {
        this.filterSearchList = Array.from(document.querySelectorAll('.filter-list-Label')).filter(label => label.innerText.indexOf(this.filterSearchText) > -1)
      }
      this.filterSearchTotalCount = this.filterSearchList.length;
      this.filterSearchMove();
    },
    /**
     * 필터 검색 결과 초기화
     */
    initFilterSearchResult() {
      //this.filterSearchList = Array.from(document.querySelectorAll('.filter-list-Label'))
      this.filterSearchList.forEach(item => {
        item.innerHTML = item.innerText;
      });
      this.filterSearchList = [];
      this.filterSearchTotalCount = 0;
      this.filterSearchCurrent = 1;
    },
    /**
     * 필터 검색결과 이동 처리
     */
    filterSearchMove() {
      this.filterSearchList.forEach((item, idx) => {
        if (this.filterSearchCurrent === idx + 1){
          // 검색 -> 현재 선택
          item.innerHTML = item.innerText.replaceAll(this.filterSearchText, '<em class="on-search-selected">' + this.filterSearchText + '</em>');
          // 스크롤 이동
          const parentEl = item.closest('.check-list-box');
          const togleEl = item.closest('.filter-list-box').querySelector('.filterListToggle');
          // 해당 필터 항목이 숨겨져 있을경우 처리
          if (togleEl.classList.contains('close')) {
            togleEl.classList.remove('close');
            togleEl.closest('.filter-list-box').classList.remove('off');
          }
          // 해당위치로
          parentEl.scrollTo(0, item.offsetTop - parentEl.offsetTop - 10);
        } else {
          // 검색 -> 미선택
          item.innerHTML = item.innerText.replaceAll(this.filterSearchText, '<em class="on-search">' + this.filterSearchText + '</em>');
        }
      })
    },
    /**
     * 필터 조건 문자열로 변환
     * @param keyStr
     * @param titleData
     * @returns {{}}
     */
    pathFilterStr(keyStr, titleData) {
      const arrTitle = titleData.map(keys => keys.levelTitle)
      const filter = keyStr.split(this.delimiterCha).splice(2)
      const result = {}
      filter.forEach((item, index) => {
        if (item !== '') {
          result[arrTitle[index]] = item
        }
      })
      return result;
    },
    /**
     * 전체 옵션 체크박스 선택/해제
     * @param treeChecker
     * @param event
     */
    filterAllCheck(treeChecker, event) {
      treeChecker.forEach(checker => {
        checker.updateCheckAll(event.target.checked);
      });
    },
    /**
     * 1레벨 체크박스가 모두 선택/해제 일 경우 전체선택 상태를 업데이트 처리
     * @param arrData
     * @param target
     * @param model
     */
    allCheckFromChild(arrData, target, model) {
      model.checked = this.isAllCheck(arrData);
      //target.checked = this.isAllCheck(arrData);
    },
    /**
     * 전체 체크 상태여부 확인
     * @param arrData
     * @returns {boolean}
     */
    isAllCheck(arrData) {
      let result = true;
      arrData.forEach((item) => {
        if (item.checked === false) {
          result = false;
        }
        if (item.child && Array.isArray(item.child) && result) {
          if (!this.isAllCheck(item.child)) {
            result = false;
          }
        }
      });
      return result;
    },
    /**
     * 차트 종류 선택 이벤트 처리
     * @param type
     * @param name
     * @param stack
     */
    selectChart(type, name, stack) {
      this.selectChartIcon = name;
      this.chartType = type;
      this.chartName = name;
      this.stackYn = stack;
      this.initChart(this.arrayDataFilter);
    },
    /**
     * 데이터 필터 처리
     */
    filterApply() {
      this.showSpinner = true
      this.$refs.SpinnerChart.showLoading(true);

      setTimeout(() => {
        // 원본 데이터에서 필터 데이터로 변환
        this.arrayDataFilter = this.arrayData // 초기데이터
        if (this.arrayYearItemFilterData && !this.$refs.checkAllYear.checked) { // 전체 선택 일경우 제외
          let result = [];
          this.arrayYearItemFilterData.forEach((item) => {
            if (item.checked) {
              result.push({
                key: item.filterKey,
                value: item.itemName,
              });
            }
          });
          if (result.length === 0) {
            this.$set(this.$refs.checkAllYear, 'checked', true);
            this.$refs.yearTreeChecker.forEach(checker => {
              checker.updateCheckAll(true);
            })
          } else {
            const arrayKeys = [...new Set(result.map(item => item.key))]
            arrayKeys.forEach(key => {
              let arrayFilterStr = result.filter(item => item.key === key).map(item => item.value)
              this.arrayDataFilter = this.getDataFilter(this.arrayDataFilter, key, arrayFilterStr)
            })
          }
        }
        // 항목 데이터 필터 처리
        if (this.arrayColItemFilterData && !this.$refs.checkAllCol.checked) { // 전체 선택 일경우 제외
          let result = []
          result.push(...this.extraFilter(this.arrayColItemFilterData, this.arrayColItemTitleData))
          // 전체 선택이 false 인데 체크된 데이터가 없을 경우 전체 선택을 체크해주고 필터는 수행하지 않음
          if (result.length === 0) {
            this.$set(this.$refs.checkAllCol, 'checked', true);
            this.$refs.colTreeChecker.forEach(checker => {
              checker.updateCheckAll(true);
            })
          } else {
            let tempArrayFilteredData = [];
            result.forEach(filterItem => {
              let tempArrayData = this.arrayDataFilter // 필터된 데이터
              const arrKey = Object.keys(filterItem)
              arrKey.forEach(key => {
                tempArrayData = tempArrayData.filter(item => item[key] === filterItem[key])
              })
              tempArrayFilteredData.push(...tempArrayData)
            })
            this.arrayDataFilter = tempArrayFilteredData;
          }
        }
        // 통계분류 데이터 필터처리
        if (this.arrayRowItemFilterData && !this.$refs.checkAllRow.checked) { // 전체 선택 일경우 제외
          //result.push(...this.extraFilter(this.arrayRowItemFilterData, this.arrayRowItemTitleData));
          let result = []
          result.push(...this.extraFilter(this.arrayRowItemFilterData, this.arrayRowItemTitleData));
          // 전체 선택이 false 인데 체크된 데이터가 없을 경우 전체 선택을 체크해주고 필터는 수행하지 않음
          if (result.length === 0) {
            //this.$refs.checkAllRow.checked = true
            this.$set(this.$refs.checkAllRow, 'checked', true);
            this.$refs.rowTreeChecker.forEach(checker => {
              checker.updateCheckAll(true);
            })
          } else {
            let tempArrayFilteredData = [];
            result.forEach(filterItem => {
              let tempArrayData = this.arrayDataFilter // 필터된 데이터
              const arrKey = Object.keys(filterItem)
              arrKey.forEach(key => {
                tempArrayData = tempArrayData.filter(item => item[key] === filterItem[key])
              })
              tempArrayFilteredData.push(...tempArrayData)
            })
            this.arrayDataFilter = tempArrayFilteredData;
          }
        }
        this.initChart(this.arrayDataFilter);
        this.showSpinner = false;
        this.$refs.SpinnerChart.showLoading(false);
      }, 100);
    },
    /**
     * 필터 데이터 항목 검사
     * @param data
     * @param titleData
     * @returns {*[]}
     */
    extraFilter(data, titleData) {
      const result = [];
      data.forEach((item) => {
        if (item.checked) { // 체크 되어있을경우
          if (item.child && Array.isArray(item.child) && item.child.length > 0) { // 자식객체가 있을경우
            if (this.isAllCheck(item.child)) {
              // 자식이 모두 체크되어있을경우
              result.push(this.pathFilterStr(item.itemKeyPath, titleData))
            } else {
              // 자식검사
              result.push(...this.extraFilter(item.child, titleData));
            }
          } else {
            // 자식객체가 없을경우
            result.push(this.pathFilterStr(item.itemKeyPath, titleData))
          }

        }
      });
      return result;
    },

    /**
     * 차트 초기화 및 생성
     * @param arrayData
     */
    initChart(arrayData) {

      let colors = ["#fd9c3c", "#e5404c", "#f6c8ba", "#b7b0b5", "#2ea4a8", "#47586f", "#adab6e", "#c9a9c3"];
      const seriesKeyFunc = item => {
        return this.chartSetOption.seriesKey.map(key => {
          return item[key]
        }).join(this.delimiterCha);
      }

      const stackKeyFunc = item => {
        return this.chartSetOption.stackKey.map(key => {
          return item[key]
        }).join(this.delimiterCha);
      }

      // 차트 데이터 처리
      const dataFunc = (arrayData, series, stack) => {
        let tempData = arrayData;
        let seriesArr = series.split(this.delimiterCha);
        let stackArr = stack.split(this.delimiterCha);
        seriesArr.forEach((series, index) => {
          if (series && series.length > 0) {
            tempData = tempData.filter(item => item[this.chartSetOption.seriesKey[index]] === series)
          }
        })
        stackArr.forEach((stack, index) => {
         if (stack && stack.length > 0) {
           tempData = tempData.filter(item => item[this.chartSetOption.stackKey[index]] === stack)
         }
        })
        return tempData.map(item => item[this.chartSetOption.valueKey] === undefined ? 0 : item[this.chartSetOption.valueKey])
      }

      // 원 데이터에서 항목자체가 없거나 항목에 값이 없는경우 0으로 처리
      // 0으로 처리하지 않으면 차트 데이터의 순서가 변경되어 잘못된 차트가 생성됨.
      const dataFunc2 =  (categories, arrayData, series, stack) => {
        let seriesArr = series.split(this.delimiterCha);
        let stackArr = stack.split(this.delimiterCha);

        let result = []
        categories.forEach((category, years) => {
            let tempData = arrayData;
            tempData = tempData.filter(item => item[this.chartSetOption.categoriesKey] === category)
            seriesArr.forEach((series, index) => {
              if (series && series.length > 0) {
                tempData = tempData.filter(item => item[this.chartSetOption.seriesKey[index]] === series)
              }
            })
            stackArr.forEach((stack, index) => {
              if (stack && stack.length > 0) {
                tempData = tempData.filter(item => item[this.chartSetOption.stackKey[index]] === stack)
              }
            })
            //result.push(tempData.map(item => item[this.chartSetOption.valueKey] === undefined ? 0 : item[this.chartSetOption.valueKey]))
            // 항목자체가 없거나 항목에 값이 없을경우 0으로 처리
            result.push(tempData[0] === undefined ? 0 : tempData[0][this.chartSetOption.valueKey] === undefined ? 0 : tempData[0][this.chartSetOption.valueKey]);
        })
        return result;
      }
      // 파이차트 데이터 생성
      const dataFuncPie =  (categories, arrayData, series, stack) => {
        let seriesArr = series.split(this.delimiterCha);
        let stackArr = stack.split(this.delimiterCha);

        let result = []
        categories.forEach((category, yearIndex) => {
          if (yearIndex !== 0) {  // 임시 테스트
            return;
          }
          let tempData = arrayData;
          tempData = tempData.filter(item => item[this.chartSetOption.categoriesKey] === category)
          seriesArr.forEach((series, index) => {
            if (series && series.length > 0) {
              tempData = tempData.filter(item => item[this.chartSetOption.seriesKey[index]] === series)
            }
          })
          stackArr.forEach((stack, index) => {
            if (stack && stack.length > 0) {
              tempData = tempData.filter(item => item[this.chartSetOption.stackKey[index]] === stack)
            }
          })

          // 항목자체가 없거나 항목에 값이 없을경우 0으로 처리
          result.push(stack);
          result.push(tempData[0] === undefined ? 0 : tempData[0][this.chartSetOption.valueKey] === undefined ? 0 : tempData[0][this.chartSetOption.valueKey]);

        })
        return result;
      }

      // SET. 차트 생성 조건 셋팅
      let categories = [...new Set(arrayData.map(item => item[this.chartSetOption.categoriesKey]))];
      let series = [...new Set(arrayData.map(item => seriesKeyFunc(item)))];
      let stack = [...new Set(arrayData.map(item => stackKeyFunc(item)))];

      // 최근 5년치 데이터 처리
      if (this.last5Year) {
        categories = categories.slice(0, 5);
      }

      // 전체(또는 표본수, 사례수) 값을 제외하고 차트보기
      // CASE1. 첫번째 값 제거
      if (this.allValueCheck && stack.length > 0) {
        stack = stack.filter(item => item !== stack[0]);
      }
      // CASE2. 표본수, 사례수 명칭으로 제외 처리
      /*if (this.allValueCheck) {
        stack = stack.filter(item => item !== '표본수' && item !== '사례수');
        series = series.filter(item => item !== '표본수' && item !== '사례수');
      }*/

      let extraStackSize = 0;
      let seriesData = [];

      // SET DATA
      // CASE. 파이 차트일경우 처리
      if (this.chartType === 'pie' || this.chartType === 'polar') {
        let pieBaseWidth = 100 / series.length;
        let pieWidth = pieBaseWidth / 2;
        series.forEach((series, index) => {    // 구분 : 성별, 연령별
          let arrayPieData = [];
          stack.forEach((stack) => {  // 여가활동 : 사진촬영
            let data = dataFuncPie(categories, arrayData, series, stack);
            arrayPieData.push(data)
          })
          let template = {
            name: series,
            color: colors[index],
            data: arrayPieData,
            stack: stack,
            stackName : stack,
            center: [pieWidth + '%', '50%'],
            showInLegend: true
          }
          pieWidth = pieWidth + pieBaseWidth;
          seriesData.push(template)
        })
      } else {  // 파이 제외 차트
        stack.forEach((stack) => {
          series.forEach((series,  index) => {
            //let data = dataFunc(arrayData, series, stack);
            let data = dataFunc2(categories, arrayData, series, stack);
            let template = {
              name: series,
              color: colors[index],
              data: data,
              stack: stack,
              stackName : stack
            }
            // stack 여부에 따라 변경 처리
            if (!this.stackYn) {
              template.stack = stack + ' ' + series
              extraStackSize ++;
            }

            // 라인 타입일 경우 각 표두 항목을 표시
            if (this.chartType === 'line' || !this.stackYn) {
              template.dataLabels ={
                enabled:true,
                inside:false,
                formatter:function(){
                  return this.series.userOptions.stackName;
                }
              }
            } else { // 컬럼, 바 타입일 경우 첫번째에만 표두 항목을 표시
              if (index === 0) {
                template.dataLabels ={
                  enabled:true,
                  inside:false,
                  formatter:function(){
                    return this.series.userOptions.stackName;
                  }
                }
              }
            }
            seriesData.push(template)
          })

        })
      }

      // 차트 초기 속성
      this.chartOptions.initChartData = {
        chart: {
          type: this.chartType === 'polar' ? 'line' : this.chartType,   // column, line, bar
          //가로 스크롤 바
          scrollablePlotArea: {
            // minWidth: groupWidth,
            // minHeight: groupHeight,
            /*scrollPositionX: 1*/
          }
        },
        colors: ["#fd9c3c", "#e5404c", "#f6c8ba", "#b7b0b5", "#2ea4a8", "#47586f", "#adab6e", "#c9a9c3"],
        xAxis: {
          categories : this.chartType === 'polar' ? stack : categories
        },
        yAxis: {
          title:{
            enabled: false
          }
        },
        tooltip: {},
        legend: {
          enabled: false,
          align:"right",
          verticalAlign:"middle",
          layout:"verical"
        },
        plotOptions: {
          series: {
            stacking: "normal",
            shadow: false
          },
          column:{
            showInLegend: false,
            events:{
              legendItemClick:function(){return false;}
            },
            pointWidth:30,
            groupPadding: 0.05,
            pointPadding: 0.15,
            allowPointSelect: true,
          }
        },
        series: seriesData
      }

      // 영역 차트일경우 투명도 설정
      if (this.chartName === 'area' || this.chartName === 'areaspline') {
        this.chartOptions.initChartData.plotOptions.area = {fillOpacity : 0.2};
      }

      if (this.chartName === 'step') {
        this.chartOptions.initChartData.plotOptions.line = {step : true};
      }

      if (this.chartType === 'pie') {
        this.chartOptions.initChartData.plotOptions.series.dataLabels = {format : "{point.name} {point.percentage:.1f} %"}
        this.chartOptions.initChartData.plotOptions.pie = {size : "70%",dataLabels: {enabled: true,distance: -50,}}
      }

      if (this.chartType === 'polar') {
        this.chartOptions.initChartData.chart.polar = true;
      }

      // chart 초기화
      createIBChart(this.stblChartId, this.stblChartId, {
        width: "100%",
        height: "100%"
        /*width: groupWidth,
        height: groupHeight*/
      });

      this.stblChart = window[this.stblChartId]
      this.stblChart.setOptions(this.chartOptions.initChartData,{redraw:true});
    },
    /**
     * 차트 이미지 저장
     */
    saveChartToImg() {
      let saveDivSelector = ".chart-wrap";
      saveDivSelector = "#chartDiv";
      if ($(saveDivSelector).length === 0) {
        console.log("생성된 차트가 없습니다.");
        return;
      }
      const saveImg = (uri, filename) => {
        let link = document.createElement('a');
        document.body.appendChild(link);
        link.href = uri;
        link.download = filename;
        link.click();
        document.body.removeChild(link);
      };
      html2canvas(document.querySelector(saveDivSelector)).then(canvas => {
        saveImg(canvas.toDataURL(), this.chartTitle + '.png');
      });
    },

    /**
     * 데이터 필터 처리
     * @param arrayList
     * @param strTarget
     * @param arrayFilterStr
     * @returns {*}
     */
    getDataFilter(arrayList, strTarget, arrayFilterStr) {
      return arrayList.filter(function (objects) {
        let result = false;
        arrayFilterStr.forEach((item) => {
          if (item === objects[strTarget]) {
            result = true;
          }
        });
        return result;
      });
    },

  }
}
</script>

<style scoped>

</style>
